import React from 'react';
import { clsx } from 'clsx';
import CharacterAvatar from './CharacterAvatar';

const characterStyles = {
  philemon: {
    name: 'text-courtyard-olive-dark',
    bg: 'bg-courtyard-olive/5',
    border: 'border-courtyard-olive/15',
  },
  xenia: {
    name: 'text-courtyard-aegean-dark',
    bg: 'bg-courtyard-aegean/5',
    border: 'border-courtyard-aegean/15',
  },
  theron: {
    name: 'text-courtyard-clay',
    bg: 'bg-courtyard-terracotta/5',
    border: 'border-courtyard-terracotta/15',
  },
  daria: {
    name: 'text-courtyard-stone',
    bg: 'bg-courtyard-stone/5',
    border: 'border-courtyard-stone/15',
  },
};

const CharacterDialogue = ({ characterId, speaker, text, isNarration = false, className }) => {
  if (isNarration) {
    return (
      <div className={clsx('bg-courtyard-stone/5 border-l-4 border-courtyard-gold/30 rounded-r-xl px-5 py-4', className)}>
        <p className="text-courtyard-stone/80 italic leading-relaxed text-[15px]">
          {text}
        </p>
      </div>
    );
  }

  const styles = characterStyles[characterId] || {
    name: 'text-courtyard-stone',
    bg: 'bg-courtyard-stone/5',
    border: 'border-courtyard-stone/10',
  };

  return (
    <div className={clsx(
      'flex gap-3 items-start rounded-xl border p-4',
      styles.bg,
      styles.border,
      className,
    )}>
      <CharacterAvatar characterId={characterId} size="sm" />
      <div className="flex-1 min-w-0">
        <span className={clsx('font-display font-bold text-sm', styles.name)}>
          {speaker || characterId?.charAt(0).toUpperCase() + characterId?.slice(1)}
        </span>
        <p className="text-[15px] text-courtyard-stone/80 leading-relaxed mt-1">
          &ldquo;{text}&rdquo;
        </p>
      </div>
    </div>
  );
};

export default CharacterDialogue;
